var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"bar horizontal"},[_vm._v(_vm._s(_vm.snowheight)+"cm "),_c('i',{style:(("width:" + _vm._percentage + "%;"))},[_vm._v(_vm._s(_vm.snowheight)+"cm ")])])}
var staticRenderFns = []

export { render, staticRenderFns }